import React from 'react'
import { CalendarEvent, google, ics, outlook, yahoo } from 'calendar-link'
import { AppleLogo } from '../react/components/icons/AppleLogo'
import { GoogleCalendarLogo } from '../react/components/icons/GoogleCalendarLogo'
import { OutlookLogo } from '../react/components/icons/OutlookLogo'
import { YahooLogo } from '../react/components/icons/YahooLogo'
import { Calendar } from '../react/components/icons/Calendar'

export type CalendarConfigEntry = {
  icon: JSX.Element
  label: string
  dropdownLabel: string
  link: (calendarEvent: CalendarEvent) => string
}

export type CalendarType = 'apple' | 'google' | 'outlook' | 'yahoo' | 'ical'

export const CALENDAR_LINKS_CONFIG: Record<CalendarType, CalendarConfigEntry> = {
  apple: {
    icon: <AppleLogo />,
    label: 'Calendar',
    dropdownLabel: 'Apple',
    link: ics,
  },
  google: {
    icon: <GoogleCalendarLogo />,
    label: 'Google Calendar',
    dropdownLabel: 'Google',
    link: google,
  },
  outlook: {
    icon: <OutlookLogo />,
    label: 'Outlook calendar',
    dropdownLabel: 'Outlook',
    link: outlook,
  },
  yahoo: {
    icon: <YahooLogo />,
    label: 'Yahoo Calendar',
    dropdownLabel: 'Yahoo',
    link: (event: CalendarEvent) => {
      // NOTICE calendar-link lib has a bug related to yahoo time calculation
      // so let's manually add 2h here for Berlin timezone
      const start = new Date(event.start)
      start.setHours(start.getHours() + 2)

      return yahoo({ ...event, start })
    },
  },
  ical: {
    icon: <Calendar />,
    label: 'iCal',
    dropdownLabel: 'iCal',
    link: ics,
  },
}
